import { Location } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AuthService } from "src/shared/Services/auth.service";

import { Usuario } from "@shared/Entities/Usuario/usuario.entity";

import { UnitSharedService } from "@Unit/shared/services/unitshared.service";
import { PORTAL_STYLES } from "@Unit/shared/Type/config/portal-style.config";

import { MenuSection } from "../Types/menu.interface";

@Component({
  selector: "app-mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrls: ["./mobile-menu.component.scss"],
})
export class MobileMenuComponent {
  constructor(private authService: AuthService, private unitSharedService: UnitSharedService, private location: Location) {
    this.unitSharedService.isUnitPortalStyle$.subscribe((isUnit) => {
      this.isUnitPortalStyle = isUnit;
    });
  }
  @Input() public currentUser: Usuario;
  @Input() public menu: MenuSection[] = [];

  @Input() public active: boolean;
  @Output() public hideMenu = new EventEmitter<void>();
  @Output() public signOut = new EventEmitter<void>();

  public selectedSection: MenuSection;
  public prevSection: MenuSection;
  public portalStyle: string | null = "";
  public isUnitPortalStyle: boolean = false;

  public selectSection(section: MenuSection): void {
    if (section.childs[0].name === section.name) {
      this.selectedSection = section.childs[0];
      this.prevSection = null;
    } else {
      if (this.selectedSection) {
        this.prevSection = this.selectedSection;
      }
      if (this.navigateToPortal(section.name)) {
        this.selectedSection = section;
      }
    }
  }

  public back(): void {
    this.selectedSection = this.prevSection;
    if (this.selectedSection.name === this.prevSection.name) {
      this.prevSection = null;
    }
  }

  public resetPassword(): void {
    this.authService.resetPassword();
  }

  public hide(): void {
    this.hideMenu.emit();
  }

  public onClickSignOut(): void {
    localStorage.removeItem("PortalStyle");
    this.signOut.emit();
  }

  public isUnitMenu(): boolean {
    return this.isUnitPortalStyle;
  }

  public isUnitInstructivo(): boolean {
    return !this.isUnitPortalStyle;
  }

  private navigateToPortal(portalName: string): boolean {
    const lowerCasePortalName = portalName.toLocaleLowerCase();

    if (/seguros unit/i.test(lowerCasePortalName) && !this.isUnitPortalStyle) {
      localStorage.setItem("PortalStyle", PORTAL_STYLES.unit.portalStyle);
    } else if (/seguros universal/i.test(lowerCasePortalName) && this.isUnitPortalStyle) {
      localStorage.setItem("PortalStyle", PORTAL_STYLES.universal.portalStyle);
    } else {
      return true; // Si no coincide con ninguno, salir de la función.
    }

    // Cambiar la URL sin recargar la página completa
    this.location.go("portales");

    // Recargar la página después de un ligero retardo
    setTimeout(() => window.location.reload(), 50);
    return false;
  }
}
